/**
 * 生成一个 RFC 4122 V4 的随机 UUID
 * @returns {string}
 */
export const uuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    let r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * 显示loading
 */
export function showLoading() {
  document.getElementById('qe-page-loading').style.display = 'block';
}

/**
 * 关闭loading
 */
export function hideLoading() {
  document.getElementById('qe-page-loading').style.display = 'none';
}
/**
 * 是否含有空格
 */
export function hasEmpty(str) {
  return str.indexOf(' ') > -1;
}

export function copyToClip(content) {
  try {
    let oInput = document.createElement('input');
    oInput.value = content;
    document.body.appendChild(oInput);
    oInput.select(); // 选择对象;
    console.log(oInput.value);
    document.execCommand('Copy'); // 执行浏览器复制命令
    oInput.remove();
    return Promise.resolve(true);
  } catch (error) {
    return Promise.reject(true);
  }
}
export function makePathTree(array) {
  // {
  //   label: 'First floor-1',
  //   key: 'key'
  //     children: [
  //       {
  //         label: 'Second floor-1.1',
  //         children: [
  //           {
  //             label: 'Third floor-1.1.1'
  //           }
  //         ]
  //       }
  //     ]
  // },
  let res = [];
  let top = [];
  array = array.sort((a, b) => a - b);
  let node = {};
  for (let index = 0; index < array.length; index++) {
    const item = array[index];
    let itemList = item.split('/');
    let itemIndex = top.indexOf(itemList[0]);
    if (itemIndex > -1) {
      node = res[itemIndex];
    } else {
      node = {
        key: itemList[0],
        label: itemList[0]
        // children: []
      };
      top.push(itemList[0]);
      res.push(node);
    }

    let length = itemList.length;
    for (let j = 1; j < length; j++) {
      let hasItem = false;
      let currentItem = itemList[j] || '/';
      if (node.children) {
        node.children.forEach(nodeItem => {
          if (nodeItem.label === `${currentItem}`) {
            hasItem = true;
            node = nodeItem;
          }
        });
      }
      if (!hasItem) {
        let newNode = {
          key:
            currentItem === '/' ? `${node.key}/` : `${node.key}/${currentItem}`,
          label: currentItem
          // children: []
        };
        if (!node.children) {
          node.children = [];
        }
        node.children.push(newNode);
        node = newNode;
      }
    }
  }
  console.log(res);
  return res;
}
